module.exports = __webpack_public_path__ + "img/app1.9dd5e00b.jpg";